import { Component, OnInit, ViewChild, TemplateRef, Renderer2, ViewChildren, QueryList } from '@angular/core';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { DataTablesResponse } from '../shared/models/datatables-response';
import { environment } from '../../environments/environment'
import { HttpClient } from '@angular/common/http';
import { Exchange1031inquiryOutputModel } from '../shared/models/User1031ListOutputModel';
import { ValidationService } from '../shared/providers/validation.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { IBroker } from '../shared/models/BrokerListOutputModel';
import { CommonService } from '../shared/providers/common.service';
import { Trade1031Service } from '../shared/providers/Trade1031.service';
import { ToastService } from '../shared/providers/toast.service';
import { IBrokerInput } from '../shared/models/BrokerInputModel';
import { LoaderService } from '../shared/providers/loader.service';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { ILookUp } from '../shared/models/LookUpOutputModel';
import { YesNo } from '../shared/enum/enum';
import { UserManagerService } from '../shared/providers/user-manager.service';
import { IPropertyAccessInputModel } from '../shared/models/PropertyAccessInputModel';
import { ITrade1031InputModel } from '../shared/models/Trade1031InputModel';
import { MatSelect } from '@angular/material/select';

export interface exchangeModel {
  Id: string;
  Principal: string;
  SalePrice?: number;
  SaleDate?: Date;
  brokers: Array<number>[];
}
export interface CreateNewExchangeInputModel {
  ExchangeId: number;
  BrokerId: Array<number>[];
  LoggedInUserId: number;
}

@Component({
  selector: 'app-inquiry-1031',
  templateUrl: './inquiry-1031.component.html',
  styleUrls: ['./inquiry-1031.component.css']
})
export class Inquiry1031Component implements OnInit {

  constructor(private http: HttpClient, public Validation: ValidationService, private renderer: Renderer2, private _userManagerService: UserManagerService, private modalService: BsModalService, private _commonService: CommonService, private _Trade1031Service: Trade1031Service, private Toast: ToastService, private Loader: LoaderService, public Authentication: AuthenticationService) { }
  protected readonly BASE_URL: string = environment.base_url;
  inquiryList: Exchange1031inquiryOutputModel[];
  dtOptions = {};
  table: DataTableDirective;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  modalRef: BsModalRef;
  modalRefInquiry: BsModalRef;
  brokers: IBroker[];
  allBrokers: IBroker[];
  createNewExchangeInputModel = {} as CreateNewExchangeInputModel;
  IsLoading = false;
  @ViewChildren(MatSelect) matSelects!: QueryList<MatSelect>;
  //defaultBrokerText: IMultiSelectTexts = {
  //    checked: 'item selected',
  //    checkedPlural: 'items selected',
  //    defaultTitle: 'Select Brokers',
  //    searchEmptyResult: 'No results found...',
  //};
  defaultBrokerSettings = {
    singleSelection: false,
    text: "Select Brokers",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
  };
  statusList: ILookUp[];
  filterCount = [];
  rowCount = 0;
  user: any;
  ngOnInit() {
    this.user = this.Authentication.user;
    this._commonService.getLookupsByTypeId(34).subscribe(response => {
      this.statusList = response.map(o => { return { id: o.Id, description: o.Description }; }).filter(x => x.id != 2702 && x.id != 2703);
    });
    this.bindFilter();
    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "pageLength": 50,
      "order": [[1, "desc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsLoading = true;
        const filter =
        {
          Type: this.activefilterButton,
        }
        dataTablesParameters.Extra_param = filter;
        const httpHeader = this.Validation.GetAuthHeader();
        that.http.post<DataTablesResponse>(
          this.BASE_URL + '/opportunity/1031InquiryList/',
          dataTablesParameters, httpHeader
        ).subscribe(resp => {
          that.inquiryList = resp.data ? resp.data : [];
          that.inquiryList.forEach(item => {
            item.EBRASendDate = this.Validation.convertUTCDateToLocalDate(item.EBRASendDate);
          });
          if (this.rowCount == 0) {
            this.rowCount = resp.recordsTotal;
          }
          if (resp) {
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
            if (resp.data.length === 0) {
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            else {
              $(".dataTables_paginate.paging_full_numbers").show();
            }
            $(".paginate_button.first,.paginate_button.last").hide();
          } else {
            callback({
              recordsTotal: 0,
              recordsFiltered: 0,
              data: []
            });
            $(".dataTables_paginate.paging_full_numbers").hide();
          }
          this.IsLoading = false;
        });
      },
      columns: [{ data: 'InquiryDate' },
      { data: 'InquiryDate' },
      { data: 'Buyer' },
      { data: 'UserRole' },
      { data: 'SalePrice' },
      { data: 'ProjectedSaleDate' },
      { data: 'AccessTo1031' },
      { data: 'Status' },
      { data: 'InquirySource' },
      ]
    };
    this.bindBroker();
  }
  bindFilter() {
    this._commonService.GetFilterCount(1, this.user.Id).subscribe(response => {
      this.filterCount = response;
    });
  }
  ngAfterViewInit() {
    this.matSelects.forEach((matSelect) => {
      matSelect.openedChange.subscribe((isOpened) => {
        if (isOpened) {
          this.addClassToOverlayContainer();
        } else {
          this.removeClassFromOverlayContainer();
        }
      });
    });
  }
  addClassToOverlayContainer() {
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (overlayContainer) {
      this.renderer.addClass(overlayContainer, 'custom-overlay-container');
    }
  }

  removeClassFromOverlayContainer() {
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (overlayContainer) {
      this.renderer.removeClass(overlayContainer, 'custom-overlay-container');
    }
  }
  private bindBroker() {
    this._commonService.getBrokersNames().subscribe(response => {
      if (response != null && response.length > 0) {
        this.brokers = response.map(o => { return { id: o.LeadContactId, name: o.BrokerName } });
        this.allBrokers = this.brokers;
      }
    });
  }
  onSearch(text: string) {
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }
  exchange = {} as exchangeModel;
  currentExchangeId = 0;
  openCreateExchangeModel(template: TemplateRef<any>, exchangeId: number) {
    this.brokersSelected = [];
    let inquiry = this.inquiryList.find(x => x.ID === exchangeId);
    if (inquiry) {
      this.currentExchangeId = exchangeId;
      this.exchange.Id = "EX" + inquiry.ID;
      this.exchange.Principal = inquiry.Buyer;
      this.exchange.SalePrice = inquiry.SalePrice;
      this.exchange.SaleDate = inquiry.ProjectedSaleDate ? this.Validation.convertUTCDateToLocalDate(inquiry.ProjectedSaleDate) : null;
      this.modalRef = this.modalService.show(template, { class: 'panlestyle' });
    }
  }

  brokersSelected: IBroker[];
  BrokerInput = {} as IBrokerInput;
  isSubmit = false;
  saveBroker() {
    this.isSubmit = false;
    //if (this.brokersSelected.length > 0) {
    this.Loader.display(true);
    this.createNewExchangeInputModel.ExchangeId = this.currentExchangeId;
    let brokersList = [];
    this.brokersSelected.forEach(item => {
      brokersList.push(item);
    });
    this.createNewExchangeInputModel.BrokerId = brokersList;
    this.createNewExchangeInputModel.LoggedInUserId = this.user.Id;
    this._Trade1031Service.CreateNewExchange(this.createNewExchangeInputModel).subscribe(response => {
      if (response) {
        this.bindFilter();
        this.rowCount = 0;
        this.Toast.addToast({ title: 'Success', msg: 'Exchange created Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        this.modalRef.hide();
        this.dtElement.dtInstance.then(x => x.draw());
      }
      else {
        this.Toast.addToast({ title: 'Error Occurred', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
      this.Loader.display(false);
    });
    //}
    //else {
    //    this.isSubmit = true;
    //    this.Loader.display(false);
    //    //this.Toast.addToast({ title: 'Error Occurred', msg: 'Please select atleast one broker', timeout: 3000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    //}
  }

  changeInquiryStatus(statusId: number, inquiryId: number) {
    this._Trade1031Service.changeExchangeInquiryStatus(statusId, inquiryId).subscribe(response => {
      if (response) {
        this.bindFilter();
        this.Toast.addToast({
          title: 'Success', msg:
            'Status updated successfully', timeout:
            5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
        });
      }
      else {
        this.Toast.addToast({
          title: 'Error', msg:
            'Error updating status', timeout:
            5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
        });
      }
    });
    event.preventDefault();
  }
  colors = this.Validation.colorsList;
  activefilterButton = 0;
  onSortData(status: any) {
    this.activefilterButton = status;
    this.dtElement.dtInstance.then(x => x.draw());
  }

  @ViewChild('Confirmation') Confirmation: TemplateRef<any>;
  userIdToSendLink = 0;
  sendToUserLink = '';
  modalRefConfirmation: BsModalRef;
  openConfirmSendLink(userid) {
    this.userIdToSendLink = userid;
    this.sendToUserLink = '';
    let selecteduser = this.inquiryList.find(x => x.UserId == userid);
    this.sendToUserLink = selecteduser.Buyer + ' (' + selecteduser.Email + ')';
    this.modalRefConfirmation = this.modalService.show(this.Confirmation, { class: 'deletemodal' });
  }
  SendLinkToEBRA() {
    this.Loader.display(true);
    this._Trade1031Service.SendLinkToEBRA(this.userIdToSendLink).subscribe(response => {
      if (response) {
        this.modalRefConfirmation.hide();
        let selecteduser = this.inquiryList.find(x => x.UserId == this.userIdToSendLink);
        selecteduser.IsEBRALinkSent = true;
        selecteduser.EBRASendDate = new Date();
        //this.dtElement.dtInstance.then(x => x.draw());

        this.Toast.addToast({
          title: 'Success', msg:
            'Invite sent successfully', timeout:
            5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
        });
      }
      else {
        this.Toast.addToast({
          title: 'Error', msg:
            'Error sending invites', timeout:
            5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
        });
      }
      this.Loader.display(false);
    });
  }

  accessModel = {} as IPropertyAccessInputModel;
  grant1031Access(userguid, event) {
    this.accessModel.Is1031EnabledId = event.target.checked ? YesNo.Yes : YesNo.No;
    this.accessModel.UserId = userguid;
    this.inquiryList.filter(x => x.UserGuid == userguid).forEach(item => {
      item.AccessTo1031 = event.target.checked;
    });

    this._userManagerService.update1031access(this.accessModel).subscribe(response => {
      if (response) {
        this.Toast.addToast({ title: 'Success', msg: 'You have successfully changed the 1031 access status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
      }
      else {
        this.Toast.addToast({ title: 'Error', msg: 'An error Occurred while changing the 1031 access status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
    });
  }

  openCreateInquiry(template: TemplateRef<any>) {
    this.exchangeInputModel = {} as ITrade1031InputModel;
    this.isSubmitInquiry = false;
    this.modalRefInquiry = this.modalService.show(template, { class: 'panlestyle' });
  }

  isSubmitInquiry = false;
  exchangeInputModel = {} as ITrade1031InputModel;
  submitInquiry() {
    this.isSubmitInquiry = true;
    if (this.Validation.IsValid(this.exchangeInputModel.firstname) && this.Validation.IsValid(this.exchangeInputModel.lastname)
      && this.Validation.IsValid(this.exchangeInputModel.email) && this.Validation.isEmail(this.exchangeInputModel.email)) {
      this.Loader.display(true);
      this._Trade1031Service.Create1031Inquiry(this.exchangeInputModel).subscribe(res => {
        if (res["IsSuccess"] == true) {
          this.exchangeInputModel = {} as ITrade1031InputModel;
          this.dtElement.dtInstance.then(x => x.draw());
          this.modalRefInquiry.hide();
          this.Toast.addToast({ title: 'Success', msg: 'Successfully shared link', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        }
        else {
          this.Loader.display(false);
          this.Toast.addToast({ title: 'Error Occurred', msg: res["ErrorMessage"], timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        }
        this.Loader.display(false);
      });
    }
  }
}
